import React, { Component } from "react";
import { RingLoader } from "react-spinners";

export default class Loading extends Component {
  render() {
    return (
      <RingLoader color={"#0d76ff"} size={150} loading={this.props.loading} />
    );
  }
}



// WEBPACK FOOTER //
// ./src/Components/Loading.jsx